/** @jsx jsx */
import { jsx, Flex } from "theme-ui"
import PropTypes from "prop-types"

import SeparatorIcon from "components/svgs/separator"

const Separator = ({ direction }) => (
  <Flex sx={{ my: 5, width: "100%" }}>
    <SeparatorIcon flipX={direction === "right"} sx={{ width: "100%" }} />
  </Flex>
)

Separator.propTypes = {
  direction: PropTypes.string.isRequired,
}

export default Separator
